export default __webpack_public_path__ + "static/media/swipe.997a68fb.svg";